<template>
  <div class="logistics-nodes flex flex-justify">
    <div v-for="(item, index) in logisticsNodes" :key="index" class="nodes-item flex" :class="{'flex1':(index!==logisticsNodes.length-1)}">
      <div class="flex flex-col flex-acenter dec">
        <span class="iconfont ft20 cmain mb2" :class="item.icon + (nodesData[item.field]?'':' c999')"></span>
        <span class="ft12 c333 mb2">{{ item.name }}</span>
        <span class="ft12 c888 mb2">{{ dateToString(nodesData[item.field], 2) }}</span>
      </div>
      <div v-if="index!==logisticsNodes.length-1" class="line mt15 " :class="{'bg-999': activeNode < index, 'bg-main': activeNode >= index}" style="flex:1;"></div>
    </div>
  </div>
</template>

<script>
import { dateToString } from '@/utils/date-formatter'
export default {
  name: 'LogisticsNodes',
  props: {
    nodesData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      type: '',
      activeNode: 0,
      typeList1: ['海运出口', '拼箱出口', '灌箱出口'],
      logisticsNodes: [],
      // '海运出口', '拼箱出口', '灌箱出口'
      logisticsNodes1: [
        { code: '0', name: '接单', icon: 'iconbianzu16', date: '2020-09-21', field: 'OrderAcceptDate' },
        { code: '1', name: '进仓', icon: 'iconjincang', date: '2020-09-21', field: 'InWarehouseDate' },
        { code: '2', name: '订舱', icon: 'icondingcang', date: '2020-09-21', field: 'ApprovalDGDate' },
        { code: '3', name: '进港', icon: 'iconbianzu16beifen5', date: '2020-09-21', field: 'InPortDate' },
        { code: '4', name: '海关放行', icon: 'iconbianzu16beifen3', date: '2020-09-21', field: 'OutCustomsDate' },
        { code: '5', name: '开航', icon: 'iconkaihang', date: '2020-09-21', field: 'ATD' },
        { code: '6', name: '到港', icon: 'iconbianzu16beifen4', date: '2020-09-21', field: 'ATA' },
        { code: '7', name: '换单', icon: 'iconhuandanpingtai', date: '2020-09-21', field: 'ExchangeDay' },
        { code: '8', name: '提货日期', icon: 'icontihuo', date: '2020-09-21', field: 'ConsigneeDeliveryTime' },
        { code: '9', name: '提货日期', icon: 'icontihuo', date: '2020-09-21', field: 'DeliverDate' },
        { code: '10', name: '送货', icon: 'iconsonghuo', date: '2020-09-21', field: 'DeliverDate' }
      ],
      logisticsNodes2: [
        { name: '接单', icon: 'iconbianzu16', date: '2020-09-21', field: 'OrderAcceptDate' },
        { name: '到港', icon: 'iconbianzu16beifen4', date: '2020-09-21', field: 'ATA' },
        { name: '海关放行', icon: 'iconfanghang', date: '2020-09-21', field: 'OutCustomsDate' },
        { name: '换单', icon: 'iconhuandanpingtai', date: '2020-09-21', field: 'ExchangeDay' },
        { name: '提货日期', icon: 'icontihuo', date: '2020-09-21', field: 'ConsigneeDeliveryTime' }
      ]
    }
  },
  created () {
    this.type = this.nodesData.Job_TypeName
    console.log(this.type)
    this.sortFuckList()
    // if (this.typeList1.indexOf(this.type) !== -1) {
    //   this.logisticsNodes = JSON.parse(JSON.stringify(this.logisticsNodes1))
    //   if (this.type === '海运出口' || this.type === '灌箱出口') {
    //     this.logisticsNodes.splice(1, 1)
    //   }
    // } else {
    //   this.logisticsNodes = JSON.parse(JSON.stringify(this.logisticsNodes2))
    //   if (this.type === '拼箱进口' || this.type === '灌箱进口') {
    //     this.logisticsNodes.splice(2, 1)
    //   }
    //   if (this.type === '海运进口' || this.type === '灌箱进口') {
    //     this.logisticsNodes[this.logisticsNodes.length - 1].field = 'DeliverDate'
    //   }
    // }
  },
  methods: {
    dateToString,
    sortFuckList () {
      switch (this.type) {
        case '海运出口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[2],
            this.logisticsNodes1[3],
            this.logisticsNodes1[4],
            this.logisticsNodes1[5],
            this.logisticsNodes1[6]
          ]
          break
        case '拼箱出口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[1],
            this.logisticsNodes1[2],
            this.logisticsNodes1[3],
            this.logisticsNodes1[4],
            this.logisticsNodes1[5],
            this.logisticsNodes1[6]
          ]
          break
        case '罐箱出口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[2],
            this.logisticsNodes1[3],
            this.logisticsNodes1[4],
            this.logisticsNodes1[5],
            this.logisticsNodes1[6]
          ]
          break
        case '海运进口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[6],
            this.logisticsNodes1[7],
            this.logisticsNodes1[4],
            this.logisticsNodes1[9]
          ]
          break
        case '拼箱进口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[6],
            this.logisticsNodes1[4],
            this.logisticsNodes1[8]
          ]
          break
        case '罐箱进口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[6],
            this.logisticsNodes1[4],
            this.logisticsNodes1[9]
          ]
          break
        case '空运出口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[4],
            this.logisticsNodes1[5],
            this.logisticsNodes1[6]
          ]
          break
        case '空运进口':
          this.logisticsNodes = [
            this.logisticsNodes1[0],
            this.logisticsNodes1[6],
            this.logisticsNodes1[4],
            this.logisticsNodes1[10]
          ]
          break
      }
      this.logisticsNodes.forEach((v, i) => {
        if (this.nodesData[v.field]) {
          this.activeNode = i
        }
      })
    }
  }
}
</script>

<style lang="less">
@import '../../../styles/var.less';
.logistics-nodes {
  height: 110px;
  border-radius: 4px;
  margin-top: 15px;
  padding: 20px 20px;
  background-color: @light-blue-bg;
  .dec {
    width: 100px;
  }
  .line {
    height: 1px;
  }
  .flex1 {
    flex: 1;
  }
}
</style>
